import styled from "styled-components";
import { Avatar, Card, Select, Typography } from "@material-ui/core";
import { Alert } from "@material-ui/lab";

export const Container = styled.div`
  ${({ isFlex, theme: { container } }) => `
    display: ${isFlex ? "flex" : "block"};
    width: 100%;
    max-width: ${container};
    margin: 0 auto;
    height: 100%;
  `}
`;

export const FormWrapper = styled.div`
  ${({ desktop }) => `
    padding: ${desktop ? "40px" : "20px"};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 400px;
    width: ${desktop ? "450px" : "100%"};
    min-width: 330px;
  `}
`;

export const StyledForm = styled.form`
  width: 100%;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const PageWrapper = styled.div`
  ${({ bgImage, isFlexHeight, theme: { colors } }) => `
    background: ${bgImage ? `url(${bgImage})` : colors.softGray};
    min-height: ${isFlexHeight ? "100%" : "100vh"};
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  `}
`;

export const RouteWrapper = styled.div`
  ${({ theme: { colors }, desktop }) => `
   background: ${colors.softGray};
    min-height: calc(100vh - 80px - ${
      desktop ? "85px" : "150px"
    }); /** Height of navbar and footer */
    width: 100%;
    padding: 48px 24px 0 24px;
    position: relative;
  `}
`;

export const RouteWrapperInner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 100%;
  max-height: 100%;
`;

export const AppWrapper = styled.div`
  ${({ theme: { colors } }) => `
    background: ${colors.softGray};
    min-height: calc(100vh - 80px); /** Height of navbar */
    width: 100%;
    padding: 48px 24px 0 24px;
    position: relative;
  `}
`;

export const AppWrapperInner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 100%;
  /* max-height: 100%; */
`;

export const CardListWrapper = styled.div`
  ${({ desktop }) => `
    display: grid;
    grid-template-columns: ${desktop ? "repeat(2, 50%)" : "repeat(1, 100%)"};
    grid-gap: ${desktop ? "25px" : "0"};
    margin: ${desktop ? "25px auto" : "0 auto"};
  `}

  ${({ mobile }) => `
    ${
      mobile &&
      `
      width: 100%;
    `
    }
  `}
`;

export const PageContainerInner = styled.div`
  display: flex;
  flex-direction: ${({ rowReverse }) => (rowReverse ? "row-reverse" : "row")};
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const StyledIconWrapper = styled(Avatar)``;

export const StyledCenteredWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const StyledErrorWrapper = styled.div`
  margin-top: 50px;
`;

export const StyledAlert = styled(Alert)`
  position: absolute;
  right: 0;
`;

export const FloatingCreateButtonWrapper = styled.div`
  ${({ desktop }) => `
    position: fixed;
    bottom: 5%;
    right: 5%;
    
    ${
      !desktop &&
      `
      bottom: -3%;
      left: 50%;
      right: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      justify-content: center;
      align-items: center;
    `
    }
  `}
`;

export const StyledCardsWrapper = styled.div`
  ${({ desktop }) => `
    margin: 0 auto;
    margin-top: ${desktop ? "50px" : "15px"};
    align-self: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  `}
`;

export const StyledCardTest = styled(Card)`
  ${({ desktop }) => `
    position: relative;
    width: ${desktop ? "500px" : "350px"};
    display: flex;
    margin: 25px 0;
    min-height: 200px;
    padding: 20px;

    ${
      !desktop &&
      `
      flex-direction: column;
    `
    }
  `}
`;

export const StyledLanguagesDropdown = styled(Select)`
  .MuiSelect-icon {
    display: none;
  }

  .MuiSelect-select.MuiSelect-select {
    padding: 0;
  }
`;

export const StyledLanguageDropdownFlag = styled.div`
  ${({ profile, desktop, imgSrc, theme: { colors } }) => `
    cursor: pointer;
    height: 35px;
    width: 60px;
    background: url(${imgSrc});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    box-shadow: inset 0 0 5px ${colors.darkGray};
    height: 20px;
    ${
      desktop
        ? `
    width: ${profile ? "50px" : "40px"};
    height: ${profile ? "30px" : "20px"};
    `
        : `
    width: ${profile ? "40px" : "40px"};
    height: ${profile ? "25px" : "20px"};
    `
    }
  `}
`;

// New test card
export const StyledCardMainContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-basis: ${({ desktop }) => (desktop ? `60%` : "100%")};
`;

export const StyledCustomMediaWrapper = styled.div`
  ${({ desktop }) => `
    height: 100%;
    position: relative;
    display: flex;
    flex-basis: 40%;
    flex-direction: column;
    justify-content: space-between;
    align-items: ${desktop ? "flex-end" : "center"};
    min-height: ${desktop ? "200px" : "100%"};
  `}
`;

export const StyledCardImage = styled.img`
  height: 100px;
  width: 100px;
`;

export const StyledCardInfoWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 140px;
  margin: 15px 0;
`;

export const StyledCircle = styled.div`
  ${({ theme: { colors } }) => `
    font-size: 16px;
    border-radius: 5px;
    background: ${colors.white};
    color: ${colors.darkGray};
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
  `}
`;

export const StyledCardHeadingWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledCardInfoOuter = styled.div`
  ${({ desktop }) => `
  align-self: ${desktop ? "flex-end" : "center"};
`}
`;

export const StyledButtonOuterWrapper = styled.div`
  ${({ desktop }) => `
    display: flex;
    justify-content: flex-end;
    flex-flow: ${desktop ? "row" : "row-reverse"};
    align-items: center;
    width: 100%;
  `}
`;

export const StyledButtonCornerWrapper = styled.div`
  ${({ desktop }) => `
    align-self: flex-start;
    flex-basis: 50%;

    ${
      !desktop &&
      `
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
    & * {
      text-align: end;
    }
    `
    }
  `}
`;
export const StyledButtonCenterWrapper = styled.div`
  ${({ desktop }) => `
    display: flex;
    justify-content: ${desktop ? "flex-end" : "flex-start"};
    align-items: center;
    flex-basis: 50%;
  `}
`;

export const StyledTestHeaderName = styled(Typography)`
  padding-left: 15px;
  white-space: nowrap;
`;
